export const navigationEvents = {
    ADD_USERS_STEPPER_FLOW_FROM_ACCOUNT: 'add_users_stepper_flow_from_account',
    REMOVE_USER_FROM_ACCOUNT: 'remove_user_from_account',
    EDIT_USER_IN_ACCOUNT: 'edit_user_in_account',
    EDIT_USERS: 'edit_users',
    REMOVE_USERS: 'remove_users',
    REMOVE_USER_ACCESS: 'remove_user_access',
    REMOVE_ACCESS_FROM_ACCOUNT: 'remove_access_from_account',
};
